// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter, RequestDataFromApi } from "@insite/client-framework/Store/Components/FindLocationModal/Handlers/LoadWarehouses";
import { getWarehouses } from "@keller/App/Services/WarehouseService";


export const XngRequestDataFromApi: typeof RequestDataFromApi = async props => {
    props.apiResult = await getWarehouses(props.apiParameter);
};

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    props.apiParameter = { ...props.parameter, expand: ["properties"] } as any;
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);

replaceInChain(chain, RequestDataFromApi, XngRequestDataFromApi);